module.exports = {
  cookiePolicyBar: {
    text: 'Wir verwenden Cookies, um Ihren Besuch bestmöglich zu gestalten. Mit der Nutzung dieser Website, stimmen Sie der Verwendung von Cookies zu. Mehr dazu, in unserer <a href=\'/de/datenschutz\'>Datenschutzerklärung</a>.'
  },
  booking_button: {
    text: 'Jetzt anfragen!',
    url: '/de/buchungsanfrage',
  },
  footer: {
    phone: 'Telefon',
    email: 'E-Mail',
    socialMediaRecommendUs: 'Empfehlen Sie uns weiter:',
    // findUsOnFB: '... auf Facebook:'
  },
  form_send_error: 'Beim Versenden des Formulars ist ein Fehler aufgetreten. Bitte kontrollieren Sie Ihre Eingabe versuchen Sie es nochmal.',
  inquiry_form: {
    please_choose: 'Bitte wählen ...',
    accommodation_selection: {
      title: 'Anfrage für unser(e)',
      apartment: 'Ferienwohnung',
      home: 'Ferienhaus',
      room: 'Ferienzimmer'
    },
    booking_period: {
      title: 'Buchungszeitraum',
      arrivalDate: 'Datum der Anreise',
      departureDate: 'Datum der Abreise'
    },
    people: {
      title: 'Anzahl der Personen',
      adults: 'Erwachsene',
      children: 'Kinder',
      ageOfChildren: 'Alter der Kinder (für genaue Berechnung des Angebots)'
    },
    personal_data: {
      title: 'Persönliche Daten',
      salutation: 'Anrede',
      salutation_f: 'Frau',
      salutation_m: 'Herr',
      salutation_family: 'Familie',
      salutation_c: 'Firma',
      salutation_title: 'Titel',
      company: 'Firma',
      firstName: 'Vorname',
      lastName: 'Nachname'
    },
    address_data: {
      title: 'Adressdaten',
      street: 'Strasse, Hausnummer',
      zip: 'Postleitzahl',
      city: 'Ort',
      country: 'Land',
      countries: {
        AT: 'Österreich',
        DE: 'Deutschland',
        CH: 'Schweiz',
        BE: 'Belgien',
        FL: 'Finnland',
        FR: 'Frankreich',
        GB: 'Großbritannien',
        HU: 'Ungarn',
        CZ: 'Tschechien',
        SL: 'Slowakei',
        IT: 'Italien',
        NL: 'Niederlande',
        NO: 'Norwegen',
        ES: 'Spanien',
        PO: 'Polen',
        LI: 'Liechtenstein',
        RO: 'Rumänien',
        US: 'USA'
      }
    },
    contact_data: {
      title: 'Kontaktdaten',
      email: 'E-Mail',
      emailConfirm: 'E-Mail bestätigen',
      phone: 'Telefon'
    },
    message: {
      title: 'Anmerkungen',
      info: 'Hinterlassen Sie eine persönliche Nachricht oder weitere Anmerkungen.'
    },
    button: {
      title: 'Buchungsanfrage senden'
    }
  },
  events: {
    registration: {
      headlines: {
        main: "",
        preAuth: 'Melde Dich hier an:',
        userData: 'Deine Benutzerdaten',
        registrationData: 'Infos für den Veranstalter',
        participantsData: 'Teilnehmer, die du angemeldet hast:',
        participantsDataDescription: 'Du kannst hier Dich selbst und andere Personen für diese Veranstaltung anmelden.'
      },
      participantElementDefaultTitle: 'Bitte fülle das Formular unterhalb aus!',
      previewMode: 'Vorschau Modus',
      eventRegistrationMailSent: 'Bitte klicke auf den Anmelde-Link in der E-Mail, die wir Dir gerade geschickt haben, um Dich bei dieser Veranstaltung anzumelden.',
      postAuthSubmitDone: 'Ihre Anmeldung wurde gespeichert.',
      applicantAuthMail: {
        subject: 'Einladung zur Veranstaltung: {{eventTitle}}',
        intro: 'Hallo!<br><br>Du erhältst diese E-Mail, weil Du Dich auf der Website des Ski-Club Lofer für eine Veranstaltung anmelden möchtest.<br><br>Bitte klicke auf den folgenden Link, um diese E-Mail-Adresse zu bestätigen und mit der Anmeldung fortzufahren:<br><br>',
        eventLink: {
          title: 'Zur Anmeldung'
        }
      }
    },
    nextEventTimer: {
      headline: 'Nächstes Event in',
      emptyDuration: 'Kein Event verfügbar',
      duration: '{{weeks}} Woche(n) {{days}} Tag(e) {{hours}} Stunde(n)'
    },
    participantTable: {
      headline: 'An- & Abmeldungen für diese Veranstaltung',
      emptyList: 'Keine öffentlichen An- oder Abmeldungen verfügbar.',
      nrOfElements: {
        registered: '{{registered}} Anmeldungen',
        rejected: '{{rejected}} Abmeldungen'
      }
    }
  }
}